import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CesaImage from "../../assets/img/cesa2x.webp";
import styles from "./Footer.module.scss";
import LogoImg from "../../assets/img/logo.svg";
import SonicLink from "../routing/SonicLink";
import { sendEventTracking } from "../../utils/GeneralUtils";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <div className={styles["footer"]}>
        <div className={styles["footer_link-border"]}>
          <div className={styles["footer_link-container"]}>
            {location.pathname.includes("jikei") ||
            location.pathname.includes("admin") ? null : (
              <div className={styles["footer__facility-link"]}>
                <SonicLink to="/facility" className={styles[""]}>
                  <img src={LogoImg} alt="SELeCT" />
                  <div>{t("CAFE BASE")}</div>
                </SonicLink>
              </div>
            )}
            <ul>
              <li className={styles["footer_link-head"]}>
                {t("お困りの方へ")}
              </li>
              <li className={styles["footer_link-wrapper"]}>
                <SonicLink
                  to="/info/service/"
                  hash="#company"
                  className={styles["link"]}
                  onClick={() =>
                    sendEventTracking("click", "ServicePage", "toCompany")
                  }
                >
                  企業の方はこちら
                </SonicLink>
              </li>
              <li className={styles["footer_link-wrapper"]}>
                <SonicLink to="/info/service" className={styles["link"]}>
                  {t("SELeCTとは？")}
                </SonicLink>
              </li>
              <li className={styles["footer_link-wrapper"]}>
                <SonicLink to="/info/guide" className={styles["link"]}>
                  {t("ご利用ガイド")}
                </SonicLink>
              </li>
              <li className={styles["footer_link-wrapper"]}>
                <SonicLink to="/contact" className={styles["link"]}>
                  {t("お問い合わせ")}
                </SonicLink>
              </li>
            </ul>
            <ul>
              <li className={styles["footer_link-head"]}>{t("企業情報")}</li>
              <li className={styles["footer_link-wrapper"]}>
                <SonicLink to="/info/privacy" className={styles["link"]}>
                  {t("プライバシーポリシー")}
                </SonicLink>
              </li>
              <li className={styles["footer_link-wrapper"]}>
                <SonicLink to="/info/terms-members" className={styles["link"]}>
                  {t("一般会員利用規約")}
                </SonicLink>
              </li>
              <li className={styles["footer_link-wrapper"]}>
                <SonicLink to="/info/terms-persons" className={styles["link"]}>
                  {t("eスポーツパーソン利用規約")}
                </SonicLink>
              </li>
              <li className={styles["footer_link-wrapper"]}>
                <SonicLink
                  to="/info/disclosureapplication"
                  className={styles["link"]}
                >
                  {t("個人情報に関する開示等申請についてのご案内")}
                </SonicLink>
              </li>
              <li className={styles["footer_link-wrapper"]}>
                <a
                  href="https://sonic-boom.tokyo/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["link"]}
                >
                  {t("運営会社サイトへ")}
                </a>
              </li>
            </ul>
            <ul className={styles["footer_link-sns"]}>
              <li className={styles["footer_link-wrapper"]}>
                <a
                  href="https://twitter.com/esports_select"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["link"]}
                >
                  <FontAwesomeIcon
                    icon={["fab", "x-twitter"]}
                    className={styles["external-link-alt"]}
                  />
                </a>
              </li>
              <li className={styles["footer_link-wrapper"]}>
                <a
                  href="https://www.youtube.com/channel/UCsl-1MPmlVfVHGl2Pr3DhUg"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["link"]}
                >
                  <FontAwesomeIcon
                    icon={["fab", "youtube"]}
                    className={styles["external-link-alt"]}
                  />
                </a>
              </li>
              <li className={styles["footer_link-wrapper"]}>
                <a
                  href="https://www.instagram.com/esports_select/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["link"]}
                >
                  <FontAwesomeIcon
                    icon={["fab", "instagram"]}
                    className={styles["external-link-alt"]}
                  />
                </a>
              </li>
              <li className={styles["footer_link-wrapper"]}>
                <a
                  href="https://www.tiktok.com/@esports_select/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["link"]}
                >
                  <FontAwesomeIcon
                    icon={["fab", "tiktok"]}
                    className={styles["external-link-alt"]}
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles["footer__companyimg"]}>
          <img
            src={CesaImage}
            className={styles["footer__companyimg-item"]}
            alt="一般社団法人コンピュータエンターテインメント協会 ロゴ画像"
          />
        </div>
        <div className={styles["footer__copywrite"]}>
          &#169; 2020 Sonic Boom Entertainment Inc.
        </div>
        <div className={styles["footer__navigation-space"]} />
      </div>
    </footer>
  );
};

export default Footer;
